import { render, staticRenderFns } from "./noFooter.vue?vue&type=template&id=7c3270b6&"
import script from "./noFooter.vue?vue&type=script&lang=js&"
export * from "./noFooter.vue?vue&type=script&lang=js&"
import style0 from "./noFooter.vue?vue&type=style&index=0&id=7c3270b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports